export enum AlgoliaFilterValueType {
  MATCH = 'match',
  NUMERIC_RANGE = 'numeric-range',
}

export type AlgoliaFilterValue =
  | {
      type: AlgoliaFilterValueType.MATCH
      value: string
    }
  | {
      type: AlgoliaFilterValueType.NUMERIC_RANGE
      value: {
        min?: number
        max?: number
      }
    }
